// extracted by mini-css-extract-plugin
export var chip = "_d2-0";
export var filterDropdown = "_d2-5";
export var filterItem = "_d2-6";
export var icon = "_d2-1";
export var removeButton = "_d2-3";
export var removeIcon = "_d2-4";
export var separator = "_d2-2";